import { render, staticRenderFns } from "./ModalAddAvaliacaoGeral.vue?vue&type=template&id=9e03ad3a"
import script from "./ModalAddAvaliacaoGeral.vue?vue&type=script&lang=ts"
export * from "./ModalAddAvaliacaoGeral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports